import { render, staticRenderFns } from "./EbiArticle.vue?vue&type=template&id=0e8ab270&scoped=true&"
import script from "./EbiArticle.vue?vue&type=script&lang=js&"
export * from "./EbiArticle.vue?vue&type=script&lang=js&"
import style0 from "./EbiArticle.vue?vue&type=style&index=0&id=0e8ab270&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8ab270",
  null
  
)

export default component.exports